import { Emit, Options, Vue } from 'vue-property-decorator';
import { namespace } from 's-vuex-class';
import { User } from '@/types';

const app = namespace('app');
const chat = namespace('chat');

@Options({})
export default class UserSettingsComponent extends Vue {
  @chat.Getter private readonly me!: User;
  @app.Action private readonly setIsShowUserSettings!: (value: boolean) => void;
  @app.Action private readonly setIsShowChangePassword!: (value: boolean) => void;
  @app.Action private readonly setIsShowSignOutDialog!: (value: boolean) => void;

  public handlerClickChangePassword() {
    this.setIsShowUserSettings(false);
    this.setIsShowChangePassword(true);
  }

  public handlerClickAdminSettings() {
    this.setIsShowUserSettings(false);
    this.$router.push({ name: 'admin-whitelist' });
  }

  public handlerClickSignOut() {
    this.setIsShowUserSettings(false);
    this.setIsShowSignOutDialog(true);
  }

  @Emit('close')
  close(): void {
    return;
  }
}
